import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";

export default class RetailerFormsPopupController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.retailerId = options.retailerId;
		$ctrl.vendorFormId = options.vendorFormId;
		$ctrl.title = options.title || "Forms";
	}
	$onInit() {
		const $ctrl = this;
	}
}
